import Vue from 'vue'
import Vuex from 'vuex'
import router from './router/index'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,
  user: null
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggle (state, variable) {
    state[variable] = !state[variable]
  },
  fetchUser (state) {
    if (localStorage.getItem("api_token")) {
      axios.get('https://server.paireports.live/api/fetchUser?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        console.log('fetch user')
          console.log(response)
          // window.localStorage.setItem('roles', JSON.stringify(response.data.menuroles))
          state.user = response.data
      }).catch(function (error) {
        console.log('not there')
        console.log(router)
        console.log(router.currentRoute.path)
        setTimeout(function () {
          console.log('running')
          if (router.currentRoute.path.substr(0, 14) !== '/register_user') {
            router.push('/login')
          }
        }, 500)
      });
    } else {
        console.log('not there')
      
        setTimeout(function () {
          console.log('running')
          if (router.currentRoute.path.substr(0, 14) !== '/register_user') {
            router.push('/login')
          }
        }, 500)
    }
  },
}

export default new Vuex.Store({
  state,
  mutations
})